import React, {useEffect} from 'react';
import {getCurrent, getCurrentAccountType, getCurrentShopper} from "../../domain/loginSlice";
import {useSearchParams} from "react-router-dom";
import {getSiteId, saveSiteId} from "../../domain/siteSlice";

const DataHandle = ({children}) => {
    const currentAccountType = getCurrentAccountType();
    const [searchParams] = useSearchParams();
    const siteId = searchParams.get("siteId");

    useEffect(() => {
        if (siteId) {
            saveSiteId(siteId);
        } else {
            saveSiteId(getSiteId());
        }
    }, [siteId]);

    useEffect(() => {
        if (!window.current) {
            if (currentAccountType === 'SHOPPER') {
                getCurrentShopper();
            } else {
                getCurrent();
            }
            window.current = true;
        }
    }, []);
    return (children);
};

export default DataHandle;